<template>
    <li class="flex justify-between items-center border-b py-3">
        <div class="flex items-center text-xs">
            <div class="bg-gray-200 rounded-full h-6 w-6 flex items-center justify-center opacity-70">
                <i :class="icon" class="text-gray-600" />
            </div>
            <span class="text-gray-600 ml-4">{{ label }}</span>
        </div>
        <span :class="getColor" class="font-bold text-sm">{{ value }}
            <i v-if="color === 'green'" class="fas fa-caret-down ml-1" />
        </span>
    </li>
</template>

<script>
export default {
    props: {
        icon: { type: String, required: true },
        label: { type: String, required: true },
        value: { type: String, required: true },
        color: { type: String }
    },
    computed: {
        getColor(){
            return {
                'red': 'text-red-500',
                'green': 'text-green-400'
            }[this.color]
        }
    }
}
</script>
